export const ISSUE_REPLACEMENT_TEXT = 'Issued Item Replacement for';
